import InvestorOnboardingContent from './investor-onboarding-content';

export default InvestorOnboardingContent;
